import { themr } from 'react-css-themr';
import React from "react";
import getConfig from '~/config';
import {connect} from '~/redux/connect';
import identify from "~/identify";

import Websail from "react-booking-form/src/index.tsx"


import { parseDate, normalizeDate, dateFormat } from "react-booking-form/src/helpers/date.ts"

import { DateField, Dialog, Dropdown, Text, Input, Checkbox, IconMenu, IconButton, TimeField, Portal, RadioGroup, Radio, SelectField, OptionsManagerField, SpinnerButton, MenuGroup, MenuItem, renderHTML, useThemeColors } from '~/native-ui';

import {push} from "redux-little-router";

import cn from 'classnames';
import get from "lodash/get";
import set from "lodash/set";
import merge from "lodash/merge";
import pick from "lodash/pick";
import theme from "./theme";
import axios from "~/axios";
import { getRouter } from '~/stateGetter';
import { GlobalErrorBoundary } from '../../App/GlobalErrorBoundary';
import MessageList from "~/ui/components/MessageList/MessageList";
import { withResponsiveFlags } from '~/hoc/withResponsiveProps';

const getInputField = (passedProps) => ({ trans, onPaste, error, ...props}) => <Input error={error && props.label} { ...props } {...passedProps} onPaste={ onPaste || undefined } />



const SelectFieldTemplate = React.memo(({ value, disabled }) => <Text cursor={disabled ? "not-allowed" : undefined} fontSize="14">{value}</Text>)
const selectTemplate = (...args) => {
    const [x, props ={} ] = args;

    return renderHTML(`${get(x, 'label')}`, { Text: (args) => <SelectFieldTemplate {...props} {...args} /> })
};


const getFlattenedOptions = (options) => options.reduce((flat, option) => {
    if (!option.children) return flat.concat(option);

    flat.push({ ...option, disabled: true, isGroupHeader: true });
    return flat.concat(option.children.map((x) => ({ ...x, isGroupedOption: true })));
}, [])


// const getFlattenedOptions = (options, labelKey = "label") => options.reduce((flat, option) => {
//     const getLabel = (option) => typeof option[labelKey] !== "object" ? `<span>${option[labelKey]}</span>` : option[labelKey];
//     if (!option.children) return flat.concat({ ...option, [labelKey]: getLabel(option) });

//     flat.push({ ...option, [labelKey]: getLabel(option), disabled: true, isGroupHeader: true });
//     return flat.concat(option.children.map((x) => ({ ...x, [labelKey]: getLabel(x), isGroupedOption: true })));
// }, [])

const SelectComponent = ({ options, error, ...otherProps }) => {
    const source = React.useMemo(() => getFlattenedOptions(options, otherProps.labelKey), [JSON.stringify(options)]);
    return <Dropdown labelKey="label" error={error && otherProps.label } template={ selectTemplate } disableVirtualization={true} initialNumToRender={200} source={ source } {...otherProps} />
};



const tabStyle = { backgroundColor: '#fafaf9' };
const TabsComponent = ({ children }) => {
    return <div className={ theme.tabs } style={tabStyle}>{children}</div>
}

const PortalComponent = ({ hostName = "dialogContainerButtons", ...props}) => {
    return <Portal hostName={hostName} { ...props } />
}

const ButtonComponent = (props) => {
    const renderProps = {
        label:  (props.isSmallScreen && (props.leftIcon || props.rightIcon))? null : <Text fontSize="xs" fontWeight="500">{props.label}</Text>,
        type: props.type,
        icon: props.leftIcon || props.rightIcon,
        primary: props.variant === "primary" || props.variant === "primary-outline",
        onClick: props.onClick,
        disabled: props.disabled,
        className: cn(theme.button, props.className),
        iconClassName: cn(theme.button_font_icon, props.iconClassName),
        raised: (props.variant || "").includes("outline"),
    }
    return <SpinnerButton {...renderProps} />
}

const ResponsiveButtonComponent = withResponsiveFlags(ButtonComponent, { includeKeys: ['isSmallScreen' ]})



const Wizard = ({props}) => {
    const { buttons, body, stepDescription, AppContext, itemBarRef } = props;
    const tabProps = pick(props, "steps", "activeIndex", "onChange");
    const barProps = {
        left: <TabsComponent { ...tabProps } />,
        right: buttons,
    }

    return (
        <>
            <PortalComponent><AppContext>{ buttons }</AppContext></PortalComponent>
            <div>
                { stepDescription }
                { body }
            </div>
        </>
    )
}


const DialogComponent = ({ onClose, footer, children, ...otherProps }) => {
    return (
        <Dialog className={ theme.dialog } active onClose={ onClose } actions={ footer } { ...otherProps }>
            <div className={theme.dialogBody }>{ children }</div>
        </Dialog>
    )
}


const CheckboxComponent = ({ error, label,  ...props }) => {
    const checkboxProps = {
        ...props,
        children: error || label,
    }
    return <Checkbox { ...checkboxProps} />
}


const SearchNSelect = connect()(({ className, name, options, label, hasRemoteSource, fetchOptions, onQueryChange, loading, templateValueClassName, query, meta, error, ...props}) => {
    const timeoutref = React.useRef(null);
    const [ userInput, setUserInput ] = React.useState(query);
    const [cachedOptions, setCachedOptions] = React.useState(options);
    const queryRef = React.useRef(query ?? "");

    React.useEffect(() => {
        if (!loading) setCachedOptions(getFlattenedOptions(options, props.labelKey).map((option) => {
            let text = option[props.labelKey];

            return { ...option, text }
        }));
    }, [loading, options]);


    React.useEffect(() => {
        if (query!== undefined) return;
        setUserInput("");
    }, [query, setUserInput])

    const selectFieldProps = {
        name,
        query: userInput,
        title: label,
        error: error && name,
        requestGroup: name,
        validationMessage: meta.touched && meta.error ? label  : "",
        options: cachedOptions,
        className: theme.selectField,
        isAutocomplete: hasRemoteSource,
        onQueryChange: (query) => {
            setUserInput(query);
            queryRef.current = query;
            clearTimeout(timeoutref.current);
            timeoutref.current = setTimeout(() => {
                onQueryChange(queryRef.current);
            }, 100);
        },
        fetchOptions: (newQuery) => {
            return fetchOptions(newQuery)
        },
        autocomplete: { value: cachedOptions, status: loading ? identify.STATUS_STARTED : null },
        optionClassName: theme.autocomplete_option,
        selectedOptionClassName: theme.selectedOption,
        templateValueClassName: cn(templateValueClassName, theme.autocomplete_selection),
        template: selectTemplate,
        minQueryLength: 0,
        ...props
    }

    return <>
    {hasRemoteSource && <OptionsManagerField { ...selectFieldProps } />}
    <SelectField allowFiltering { ...selectFieldProps } />
    </>
})

const AccordionItem = ({ isInline, ...props }) => {
    return <div { ...props } className={cn(props.className, theme.accordionItem)} />
}

const MenuItemComponent = (props) => {
    const name = props.name;
    const onChange = props.onClick;
    const onClick = React.useCallback(() => {
        onChange(name);
    }, [onChange, name])

    const menuProps = {
        onClick,
        icon: props.icon,
        checkable: props.showCheckbox,
        caption: props.caption,
        value: props.name,
    }



    return <MenuItem { ...menuProps } />
}

const Menu = (props) => {
    const { value, icon, label, onChange } = props;
    const items = get(props, "items", React.useRef([]).current);
    const menuProps = {
        icon: icon,
        label: label,
        buttonProps: { type: "button" },
        menuProps: { closeOnSelect: false, },
    }

    const values = items.map((x)=> get(value, x.props.name) && x.props.name).filter(Boolean);
    const selections = React.useMemo(() => values, [JSON.stringify(values)]);
    const onItemClick = React.useCallback((name) => {
        onChange(merge({}, value, set({}, name, !get(value, name))))
    }, [onChange, JSON.stringify(value)])


    return (
        <IconMenu { ...menuProps }>
            <MenuGroup checkbox value={selections}>
                { get(props, "items", []).map((menuItemProps) => <MenuItemComponent onClick={ onItemClick } { ...menuItemProps.props} />, []) }
            </MenuGroup>
        </IconMenu>
    )
}


const getFormattedDate = (value, format) => {
    return value ? dateFormat(normalizeDate(value), format) : ""
}

const getDateTimeComponent = ({ format, mask, Component, containerClassName, extractValue }) => (allProps) => {
    const { label, value, error, ...props } = allProps;
    const dateRef = React.useRef(getFormattedDate(value, format));
    const shouldUpdateFromProp = React.useRef(true);
    const [, updateDate] = React.useState("");


    React.useEffect(() => {
        if (!shouldUpdateFromProp.current) shouldUpdateFromProp.current = true;
        else dateRef.current = getFormattedDate(value, format);
    }, [value, format, getFormattedDate])


    const onChange = props.onChange;
    props.onChange = (e = "") => {
        const isValidDate = !!e && e.length >= format.length;
        const date = e ? extractValue(e, format) : "";
        const parsedDate = parseDate(date, format);
        const value = (isValidDate && !isNaN(parsedDate.getDate()) && parsedDate) || null

        shouldUpdateFromProp.current = false
        if (value) {
            onChange(value);
            dateRef.current = dateFormat(value, format);
        } else {
            onChange(null);
            dateRef.current = e;
        }

        updateDate(new Date().getTime());
    }

    return <Component validationMessage={ error && label } containerClassName={ containerClassName } mask={ mask } title={ label } value={ dateRef.current } { ...props } />
}



const DateComponent = getDateTimeComponent({
    format: "dd.MM.yyyy",
    mask: "11.11.1111",
    Component: DateField,
    containerClassName: theme.dateFieldContainer,
    extractValue: (value, format) => value.substring(0, format.length)
})


const TimeComponent = getDateTimeComponent({
    format: "HH:mm",
    mask: "11:11",
    Component: TimeField,
    containerClassName: theme.dateFieldContainer,
    extractValue: (value, format) => value.slice(format.length * -1)
})


const TimeSlotRows = (props) => {
    return <div { ...props } className={ cn(props.className, theme.timeslotRecords) } />
}


const TimeSlotFilterWrapper =(props) => {
    return <div { ...props } className={ cn(props.className, theme.timeslotFilterContainer) } />
}

const TimeSlotButtonWrapper = (props) => {
    return <div { ...props } className={ cn(props.className, theme.timeslotButtonContainer) } />
}

const TimeSlotButton = (props) => {
    return <ButtonComponent { ...props } variant={ props.selected ? "primary" : props.variant } />
}


const TimeSlot = ({ hasSlots, ...props}) => {
    if (!hasSlots) { return <React.Fragment />; }
    return <React.Fragment><div { ...props } className={ cn(props.className, theme.timeslotSelector) } /></React.Fragment>;
}



const modelPropMap = {
    scheduling_timespans: "timespanId",
    course_timespans: "timespanId",
    customers: "customerId"
}

const iconMap = {
    arrow: "expand-more",
    arrowup: "expand-more",
    arrowright: "chevron-right",
    edit: "edit",
    error: "error",
    cart: "shopping-cart",
    close: "delete-forever",
    calendar: "event",
    attachment: "attachment",
    pdf: "file-pdf-box",
    check: "check",
    help: "help",
}

const iconFamilyMap = {
    pdf: "material-community",
}


const BookingStateContext = React.createContext({});

const BookingStateContextProvider = ({ children }) => {
    const [ hasSuccess, setHasSuccess ] = React.useState(false);
    const onBookingFormSuccess = React.useCallback(() => setHasSuccess(true), []);

    return <BookingStateContext.Provider value={{ onBookingFormSuccess, hasSuccess }}>{ children }</BookingStateContext.Provider>
}


const RadioGroupComponent = React.memo(({ input, ...props }) => {
    return (
        <div class="ws-input-group">
            <RadioGroup {...props} { ...input }  />
        </div>
    )
})

export const adminBookingFormFactory = ({ Card, classNames, getComponents = (() => ({})) }) => {

    const getPresentationFields = ({ appContextRef, actionBarRef, title }) => {
        const AppContext = ({ Provider  = appContextRef.current?.Provider, value = appContextRef.current?.value, children }) => {
            if (!appContextRef.current) {
                appContextRef.current = {
                    value,
                    Provider,
                };
            }

            return <Provider value={value}>{ children }</Provider>
        }

        const components = {
            AppContext,
            bookingsettings: {
                basic: (props) => (
                    <Card { ...props } title={<h3 className={theme.adminSettingsTitle}>{ props.title }</h3>} className={cn(props.className, theme.adminSettings)}>
                        <div className={theme.adminSettingsWrap}>{ props.children }</div>
                    </Card>
                ),
            },
            select: SelectComponent,
            checkbox: CheckboxComponent,
            radio: Radio,
            radioGroup: RadioGroupComponent,
            menu: Menu,
            menuItem: MenuItem,
            modal: DialogComponent,
            message: ({ children, ...props}) => {
                return React.cloneElement(children, { ...props, className: cn(props.className, theme.message)})
            },
            fieldset: (props) => <fieldset { ...props } className={cn(theme.fieldSet, props.className)} />,
            accordion: {
                accordionItem: AccordionItem,
                accordionTitle: (props) => <div { ...props } className={cn(theme.accordionTitle, props.className)} />,
                accordionBody: (props) => <div { ...props } className={cn(theme.accordionBody, props.className)} />
            },
            button: ResponsiveButtonComponent,
            icon: ({ type, ...otherProps }) => <IconButton {...otherProps} p="0" iconFamily={iconFamilyMap[type]} color="inherit" pointerEvents="none" value={iconMap[type] || type} className={cn(otherProps.className, theme.font_icon, { [theme.error_icon]:  type == "error" })}  />,
            searchselect: SearchNSelect,
            textarea: getInputField({ multiline: false }),
            text: getInputField({ multiline: false }),
            date: DateComponent,
            time: TimeComponent,
            recommended: {
                wrap: ({ children }) => <React.Fragment>{ children }</React.Fragment>,
                field: ({ children }) => <React.Fragment>{ children }</React.Fragment>,
                header: ({ children }) => null,
            },
            timeslot: {
                timeslotRows: TimeSlotRows,
                timeslotFilter: TimeSlotFilterWrapper,
                timeslotButton: TimeSlotButtonWrapper,
                button: TimeSlotButton,
                timeslot: TimeSlot,
            },
            wizard: {
                wizard: (props) => <Wizard { ...props } AppContext={AppContext} itemBarRef={ actionBarRef?.current } />,
                icon: ({type}) => type ? <>{type}</> : null
            },
            bookingFormPopup: ({children}) => {
                return <Card title={ title }>{ children }</Card>
            },
            success: {
                buttons: actionBarRef ? (({ children }) => <PortalComponent className={ theme.successActionButtons } container={ actionBarRef?.current }><AppContext>{children}</AppContext></PortalComponent>) : null,
                manager: SuccessHandler
            },
            ...getComponents({ AppContext, actionBarRef, title })
        };

        return components;
    };

    const mapStateToProps = (state) => ({
        hash: getRouter(state).hash,
        query: getRouter(state).query,
        pathname: getRouter(state).pathname
    })

    const mapDispatchToProps = {
        onBookingFormSuccess: (pathname, query, hash) => push({ pathname, query, hash }, { forceChangeRootModel: true })
    }

    const mergeProps = ({ query, hash, pathname }, dispatch, props, ...args) => {
        return {
            onBookingFormSuccess: () => dispatch.onBookingFormSuccess(pathname, query, hash),
            ...props,
            ...args
        }
    }

    const SuccessHandler = connect(mapStateToProps, mapDispatchToProps, mergeProps)(({ onBookingFormSuccess }) => {
        React.useEffect(() => {
            onBookingFormSuccess()
        }, [ ]);
        return null;
    })

    const AdminBookingFormStyles = React.memo(() => {
        const { primaryColor, primaryContrast, primaryColorDark, fontFamilyHeading, fontFamilyBody } = useThemeColors();
        const style = `
            .websail h1,
            .websail h2,
            .websail h3,
            .websail h4,
            .websail h5,
            .websail h6 {
                font-family: ${fontFamilyHeading};
            }

            .websail {
                font-family: ${fontFamilyBody};
                --ws-primary-color: ${primaryColor};
                --ws-primary-color-contrast: ${primaryContrast};
                --ws-secondary-color: ${primaryColorDark};
                --ws-secondary-color-contrast: ${primaryContrast};
            }
            .${theme.tabs} > .ws-flex-row { margin-bottom: 0}
        `

        return <style>{ style }</style>
    })

    const BookingForm = ({ onClose, currentModel, ...props}) => {
        let appContextRef = React.useRef(null);


        const attributes = {};
        if (modelPropMap[currentModel.modelName]) attributes[modelPropMap[currentModel.modelName]] = currentModel.itemId


        const actionBarRef = props.actionBarRef;
        const ws = new Websail({
            axiosInstance: axios,
            apiBaseUrl: getConfig().basePublicUrl || window.location.href,
            classNames,
            appContext: {
                config: {
                    is_admin: true,
                    customerId: attributes.customerId,
                    bookingFormPopup: {
                        onBack: onClose,
                    }
                },
                presentation: getPresentationFields({ appContextRef, actionBarRef, title: <h3>{ props.trans("booking_form.create_booking") }</h3> })
            }
        });

        const bookingFormProps = {
            attributes
        }

        const AdminApp = ws.getAdminApp();

        const onErrorMessage = React.useMemo(() => {
            const messagesListProps = {
                messages: [
                    {message: props.trans('booking_form.something_went_wrong'), type: "warning"}
                ],
                level: 0,

            }

            return <MessageList { ...messagesListProps} />
        }, []);


        return (
            <GlobalErrorBoundary errorMessage={onErrorMessage}>
                <div className={ theme.adminBookingForm }>
                    <AdminBookingFormStyles />
                    <AdminApp bookingFormProps={ bookingFormProps } />
                </div>
            </GlobalErrorBoundary>
        );
    }

    const connectedAdminForm = connect()(React.memo(BookingForm));

    return themr("ADMIN_BOOKING_FORM", theme)(connectedAdminForm)
}

export const AdminBookingFormDialog = adminBookingFormFactory({
    Card: ({ title, children }) => [<React.Fragment key="title">{title}</React.Fragment>, <React.Fragment key="body">{children}</React.Fragment>],
    getComponents: ({ AppContext, actionBarRef }) => ({
        Portal: PortalComponent,
        wizard: {
            tabs: (props) => <AppContext><TabsComponent { ...props } /></AppContext>,
            buttons: actionBarRef ? (({ children }) => <PortalComponent className={ theme.dialogFormButtons }><AppContext>{children}</AppContext></PortalComponent>) : null,
        },
        cart: {
            button: (props) => <ResponsiveButtonComponent { ...props } className={ cn(props.className, theme.cart_button) } iconClassName={theme.icon_only} variant="primary" />,
            buttons: actionBarRef ? (({ children }) => <PortalComponent className={ theme.dialogCartButtons }><AppContext>{children}</AppContext></PortalComponent>) : null,
            cart: ({itemCount, title, description, ...props}) => itemCount > 0 && <div { ...props } />,
            cartTable: ({ title, description, children, ...props}) => <div { ...props } className={ theme.cart }><div className={ theme.cardTitle }>{ title }</div> { description } { children }</div>,
        },
        checkout: {
            basic: ({ title, description, children, ...props}) => <div { ...props }>{ title } { description } { children }</div>,
        }
    }),
    classNames: {
    }
});
